import React from "react"
import styles from "./styles.module.scss"

export const CheckBox = ({type="checked", disabled = false}) => {
    return(
        <div className={disabled ? styles['check-box-disabled'] : styles[`${type}-check-box`]}/>
    )
}